<template>
  <!--关联新闻页面  -->
  <div class="relaNew">
    <div class="new_box">
      <el-card>
        <div>
          <i class="el-icon-search"></i>
          <span>筛选搜索</span>
        </div>
        <div style="margin-top: 15px">
          <el-form
            :inline="true"
            label-width="120px"
            ref="search"
            size="small"
            :label-position="labelPosition"
          >
            <el-form-item label="标题">
              <el-input placeholder="请输入标题" v-model="listQuery.title"></el-input>
            </el-form-item>
            <el-form-item label="发布位置">
              <el-select clearable placeholder="请选择" size="small" v-model="listQuery.fbposition">
                <el-option
                  :key="item.id"
                  :label="item.menuName"
                  :value="item.id"
                  v-for="item in positions"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="保存时间">
              <el-date-picker
                clearable
                end-placeholder="结束日期"
                range-separator="至"
                size="small"
                start-placeholder="开始日期"
                type="daterange"
                v-model="listQuery.searchTime"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>

            <el-form-item label="状态">
              <el-select clearable placeholder="请选择" size="small" v-model="listQuery.status" :disabled="true">
                <el-option
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  v-for="item in newsStatus"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="排序">
              <el-select clearable placeholder="请选择" size="small" v-model="listQuery.sortTime">
                <el-option
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  v-for="item in sortData"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否上首页">
              <el-select clearable placeholder="请选择" size="small" v-model="listQuery.homeIn" >
                <el-option
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  v-for="item in homeInOn"
                ></el-option>
              </el-select>
            </el-form-item>
            <div>
              <el-form-item>
                <el-button
                  @click="searchNewsList()"
                  size="mini"
                  style="float: right; margin-left: 50px"
                  type="primary"
                  v-if="menuPerm('special:query')"
                >查询</el-button>
              </el-form-item>

            
            </div>
          </el-form>
        </div>
      </el-card>
      <el-card>
        <el-table
          :data="list"
          @selection-change="handleSelectionChange"
          border
          ref="multipleTable"
          style="width: 100%; flex: auto"
          tooltip-effect="light"
          :header-cell-style="getRowClass"
        >
          <!-- 多选-->
          <el-table-column label="标题" prop="newsTitle" width="200">
            <template slot-scope="scope">
            <a-tooltip>
              <template slot="title">{{scope.row.newsTitle}}</template>
              <span class="news_title">{{scope.row.newsTitle}}</span>
            </a-tooltip>
          </template>

          </el-table-column>
          <el-table-column label="发布位置" prop="menuName"></el-table-column>

          <el-table-column label="送审时间" prop></el-table-column>
          <el-table-column label="审核时间" prop="createTimestamp"></el-table-column>
          <el-table-column label="权重" prop="sort"></el-table-column>

          <el-table-column label="状态" prop="examineStatus">
            <template slot-scope="scope">
              <span v-if="scope.row.examineStatus == 2 ">未提交审核</span>
              <span v-if="scope.row.examineStatus == 3 ">审核中</span>
              <span v-if="scope.row.examineStatus == 4 ">审核未通过</span>
              <span v-if="scope.row.examineStatus == 1 ">审核通过</span>
              <span v-if="scope.row.examineStatus == 5 ">下架</span>
            </template>
          </el-table-column>
          <el-table-column align="center" class-name="small-padding fixed-width" label="操作">
            <template slot-scope="{row}">
              <el-button @click="AddNews(row.id)" size="mini" type="primary" v-if="menuPerm('special:query')">添加</el-button>
            </template>
          </el-table-column>
      
        </el-table>
        <el-pagination
          :current-page="currentPage"
          :page-size="pagesize"
          :page-sizes="[5,10,15]"
          :total="totalCount"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          style="margin-top: 20px; margin-left: 10px"
        ></el-pagination>
      </el-card>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      labelPosition: "right", //表格样式
      positions: "", //发布位置
      //查询条件:
      listQuery: {
        title: "", //标题
        searchTime: "", //保存时间
        fbposition: "", //发布位置
        status: "1", //状态
        sortTime: "", //排序
        homeIn: "" //是否上首页
      },
      startTime: "", //开始时间
      endTime: "", //结束时间
      //排序：
      sortData: [
        {
          value: "create_date",
          label: "创建时间"
        },
        {
          value: "sort",
          label: "权重"
        }
      ],
      //是否上首页：
      homeInOn: [
        {
          value: "0",
          label: "不上首页"
        },
        {
          value: "1",
          label: "上首页"
        }
      ],
      //状态：
      newsStatus: [
        {
          value: "2",
          label: "未提交审核"
        },
        {
          value: "3",
          label: "审核中"
        },
        {
          value: "4",
          label: "审核未通过"
        },
        {
          value: "1",
          label: "审核通过"
        },
        {
          value: "5",
          label: "下架"
        }
      ],
      list: [], //新闻数据
      currentPage: 1, //初始页
      totalCount: 0,
      pagesize: 10 //每页数据
    };
  },
  methods: {
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%";
      } else {
        return "";
      }
    },
    //分页
    handleSizeChange: function(size) {
      this.pagesize = size;
      this.getList();
      // console.log(this.pagesize); //每页下拉显示数据
    },
    //分页
    handleCurrentChange: function(currentPage) {
      this.currentPage = currentPage;
      this.getList();
      // console.log(this.currentPage); //点击第几页
    },
    //分页
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //发布位置
    getPosition() {
      this.getAxios("/menu/list").then(res => {
        if (res.success == true) {
          this.positions = res.content;
        }
       
        if (!res.success && res.statusCode == "401") {
         this.$message.error(res.message);
         this.$router.push('/')
        }else if(res.success==false){
          this.$message.error(res.message);
        }
      });
    },

    //新闻列表
    getList() {
      var title = this.listQuery.title,
        issuePos = this.listQuery.fbposition, //发布位置
        saveTime = this.listQuery.searchTime, //保存时间
        status = this.listQuery.status; //状态
      if (this.listQuery.searchTime == null) {
        this.startTime = "";
        this.endTime = "";
      } else {
        (this.startTime = new Date(saveTime[0]).getTime() / 1000),
          (this.endTime = new Date(saveTime[1]).getTime() / 1000);
      }
      this.postAxios("/news/listAllNewsWhithoutRole", {
        pageNum: this.currentPage,
        pageSize: 10,
        newsTitle: title, //
        menuId: issuePos, //发布位置
        // expectMenuId: expectPos, //期望位置

        examineStatus: status,
        createTimestampStart: this.startTime, // 时间范围查询开始时间
        createTimestampEnd: this.endTime // 时间范围查询结束时间
      }).then(res => {
        if(res.success == true){
              this.list = res.content;

        this.totalCount = res.totalCount;
        this.list = res.content;
        // 时间戳转时间
        this.list.map((i, index) => {
          if (i.examineStatus == "1") {
            this.examineStatus = "审核通过";
          } else if (i.examineStatus == "2") {
            this.examineStatus = "未提交审核";
          } else if (i.examineStatus == "3") {
            this.examineStatus = "审核中";
          } else if (i.examineStatus == "4") {
            this.examineStatus = "审核未通过";
          } else {
            this.examineStatus = "下架";
          }
          if (i.reviewTimestamp != null) {
            var timeTrans = new Date(parseInt(i.reviewTimestamp) * 1000);
            let reviewTimestamp = timeTrans.toLocaleString("chinese", {
              hour12: false
            });
            this.$set(this.list[index], `createTimestamp`, reviewTimestamp);
          } else {
            this.$set(this.list[index], `createTimestamp`, "");
          }

          if (i.sort != null && i.sort != 0) {
            var timeTrans = new Date(parseInt(i.sort) * 1000);
            let reviewTimestampsd = timeTrans.toLocaleString("chinese", {
              hour12: false
            });

            this.$set(this.list[index], `sort`, reviewTimestampsd);
          } else {
            this.$set(this.list[index], `sort`, "");
          }
        });
        }
        else if(res.statusCode == "401" && res.success == false){
           this.$message.error(res.message);
           this.$router.push('/')
        }else if(res.success==false){
          this.$message.error(res.message);
        }
    
      });
    },
    //点击查询功能
    searchNewsList() {
      this.currentPage = 1;
      var title = this.listQuery.title,
        issuePos = this.listQuery.fbposition, //发布位置
        saveTime = this.listQuery.searchTime, //保存时间
        status = this.listQuery.status; //状态
      if (this.value1 == null) {
        this.startTime = "";
        this.endTime = "";
      } else {
        (this.startTime = new Date(saveTime[0]).getTime() / 1000),
          (this.endTime = new Date(saveTime[1]).getTime() / 1000);
      }
      this.postAxios("/news/listAllNewsWhithoutRole", {
        pageNum: 1,
        pageSize: 10,
        newsTitle: title, //
        menuId: issuePos, //发布位置
        examineStatus: status,
        createTimestampStart: this.startTime, // 时间范围查询开始时间
        createTimestampEnd: this.endTime, // 时间范围查询结束时间
        sortField: this.listQuery.sortTime, //排序权重
        isRecommend: this.listQuery.homeIn //1上首页推荐，否则传空
      }).then(res => {
        if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push('/')
        }else if(res.success==false){
          this.$message.error(res.message);
        }
        this.list = res.content;
        this.totalCount = res.totalCount;

        // 时间戳转时间
        this.list.map((i, index) => {
          if (i.examineStatus == "1") {
            this.examineStatus = "审核通过";
          } else if (i.examineStatus == "2") {
            this.examineStatus = "未提交审核";
          } else if (i.examineStatus == "3") {
            this.examineStatus = "审核中";
          } else if (i.examineStatus == "4") {
            this.examineStatus = "审核未通过";
          } else {
            this.examineStatus = "下架";
          }
          if (i.reviewTimestamp != null) {
            var timeTrans = new Date(parseInt(i.reviewTimestamp) * 1000);
            let reviewTimestamp = timeTrans.toLocaleString("chinese", {
              hour12: false
            });
            this.$set(this.list[index], `createTimestamp`, reviewTimestamp);
          } else {
            this.$set(this.list[index], `createTimestamp`, "");
          }

          if (i.sort != null && i.sort != 0) {
            var timeTrans = new Date(parseInt(i.sort) * 1000);
            let revieTime = timeTrans.toLocaleString("chinese", {
              hour12: false
            });

            this.$set(this.list[index], `sort`, revieTime);
          } else {
            this.$set(this.list[index], `sort`, "");
          }
        });
      });
    },
    //添加要关联的新闻：
    AddNews(ids) {
      var id = this.$route.query.id;
      this.getAxios("/special/type/addNews", {
        specialTypeId: id, //类型 id
        newsInfoId: ids //新闻 id
      }).then(res => {
        if (res.success == true) {
          this.$message.success("添加成功！");
        //   this.$router.push({path:"/topicDetail"})
          this.$router.go(-1)
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (
         !res.success && res.statusCode == "401"
        ) {
           this.$message.error(res.message);
           this.$router.push('/')
        }
      });
    }
  },
  created() {
    this.getPosition(); //发布位置
    this.getList(); //获取新闻数据
  }
};
</script>
<style scoped lang="less">
.relaNew {
  width: 100%;
  height: 100%;
  .new_box {
    width: 95%;
    height: 100%;
    margin: 0 auto;
    .el-card {
      margin-top: 20px;
       /deep/ .el-button--primary {
          color: #fff;
          background-color: #409eff;
          border-color: #409eff;
          width: 100px;
        
        }
        .news_title {
  display: block;
  width: 170px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
    }
  }
}
</style>